import CSS from 'csstype';

export const rollItemContainer: CSS.Properties = {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "1rem",
    marginBottom: "1rem",
};

export const toggle: CSS.Properties = {
    margin: "2rem 0 0 0",
    fontFamily: "monospace",
    fontSize: "1.2rem",
    fontWeight: "bold",
    height: "3rem",
    width: "10rem",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
};

export const clickable: CSS.Properties = {
    cursor: "pointer",
};

export const rollButton: CSS.Properties = {
    width: "10rem",
    height: "3rem",
};

export const alertBox: CSS.Properties = {
    margin: "1rem 0 1rem 0",
};



